import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { useSDK } from '../../app';
import { LoggerFactory } from '../../utils/logger/LoggerFactory';
import { DarkenedContainer } from '../layout/darkenedContainer';
import { RatingStars } from './ratingForm';
import { RatingLabel } from './ratingLabel';

const log = LoggerFactory.getLogger('Rating');

export const Rating = observer(() => {
	const sdk = useSDK();
	const { uiStateStore, welcomeDataStore } = sdk;

	return (
		<DarkenedContainer
			onCloseClick={useCallback(() => {
				log.debug('onCloseClick');
				uiStateStore.setShowRating(false);
				sdk.uiStateStore.closeQuestionnaire();

				if (!sdk.connectionManager.isConnectionShouldBePersistent) {
					sdk.connectionManager.closeConnection();
				}
			}, [sdk, uiStateStore])}
		>
			<RatingStars scale={welcomeDataStore.data?.rateGradations as number} />
			<RatingLabel />
		</DarkenedContainer>
	);
});
